import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.935 16.189"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M36.017 8.19a4 4 0 0 0-3 1.33l-.23-.09A29.6 29.6 0 0 0 28.017 8a8 8 0 0 0-16 0h-.22a29.5 29.5 0 0 0-4.6 1.39l-.23.09a4 4 0 1 0 .93 1.78 27.6 27.6 0 0 1 4.29-1.29 8 8 0 0 0 15.57 0 27.6 27.6 0 0 1 4.29 1.28 4 4 0 1 0 3.97-3.06m-32 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2m16 0a6 6 0 1 1 6-6 6 6 0 0 1-6 6m16 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2m-13-6a3 3 0 1 1-3-3 3 3 0 0 1 3 3" }, null, -1)
  ]))]))
}
export default { render: render }